var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcFilePdf = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 34,
    viewBox: "0 0 28 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3498 9.3487L18.2998 1.2987C17.6832 0.682031 16.8332 0.332031 15.9498 0.332031H3.99984C2.1665 0.332031 0.683171 1.83203 0.683171 3.66536L0.666504 30.332C0.666504 32.1654 2.14984 33.6654 3.98317 33.6654H23.9998C25.8332 33.6654 27.3332 32.1654 27.3332 30.332V11.7154C27.3332 10.832 26.9832 9.98203 26.3498 9.3487ZM17.3332 10.332C16.4165 10.332 15.6665 9.58203 15.6665 8.66536V2.83203L23.1665 10.332H17.3332Z",
    fill: "#172B4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41593 23.6413V26.6695H3.99976V18.5195H7.11758C8.02812 18.5195 8.7502 18.7565 9.28383 19.2304C9.82119 19.7043 10.0899 20.3313 10.0899 21.1112C10.0899 21.9098 9.82679 22.5311 9.30062 22.9752C8.77819 23.4192 8.04491 23.6413 7.10079 23.6413H5.41593ZM5.41593 22.505H7.11758C7.62136 22.505 8.00573 22.3874 8.27068 22.1523C8.53563 21.9135 8.6681 21.5702 8.6681 21.1224C8.6681 20.682 8.53376 20.3313 8.26508 20.07C7.9964 19.8051 7.62696 19.6689 7.15677 19.6614H5.41593V22.505Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3325 26.6695V18.5195H13.7395C14.4597 18.5195 15.0978 18.68 15.6538 19.0009C16.2136 19.3218 16.6465 19.7771 16.9525 20.3667C17.2585 20.9563 17.4115 21.6318 17.4115 22.393V22.8016C17.4115 23.5741 17.2566 24.2533 16.9469 24.8392C16.6409 25.425 16.2024 25.8766 15.6314 26.1938C15.0642 26.5109 14.413 26.6695 13.6779 26.6695H11.3325ZM12.7487 19.6614V25.5388H13.6723C14.4149 25.5388 14.984 25.3075 15.3795 24.8447C15.7788 24.3783 15.9822 23.7103 15.9897 22.8408V22.3874C15.9897 21.503 15.7975 20.8276 15.4131 20.3611C15.0288 19.8947 14.4709 19.6614 13.7395 19.6614H12.7487Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5184 23.2159H20.2382V26.6695H18.822V18.5195H23.9998V19.6614H20.2382V22.0852H23.5184V23.2159Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcFilePdf);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-file-pdf.a8963beda5a0b8a486110825aa397de8.svg";